import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarClock } from "lucide-react";
import { api, gbp } from "../../lib/api";

function Chip({ c }) {
  const up = c.pct > 0;
  return (
    <Link to={`/products/${c.supplier_product_id}`} className="shrink-0 rounded-md border border-slate-200 bg-white px-3 py-2 hover:border-emerald-300 transition-colors" data-testid={`last-year-chip-${c.supplier_product_id}`}>
      <p className="text-sm font-medium text-slate-900 max-w-[200px] truncate">{c.description}</p>
      <p className="text-xs text-slate-500">{c.supplier_name} · <span className="font-mono">{gbp(c.from_price)} → {gbp(c.to_price)}</span> <span className={`font-mono font-semibold ${up ? "text-rose-600" : "text-emerald-700"}`}>{up ? "+" : ""}{c.pct}%</span></p>
    </Link>
  );
}

export default function LastYear({ restaurantId }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    setData(null);
    api.get("/insights/last-year", { params: { restaurant_id: restaurantId || undefined } }).then((r) => setData(r.data)).catch(() => {});
  }, [restaurantId]);
  if (!data) return null;
  const empty = data.last_year_changes.length === 0 && data.year_on_year.length === 0;
  return (
    <section className="bg-white border border-slate-200 rounded-lg p-4" data-testid="last-year">
      <div className="flex items-center gap-2 mb-2">
        <CalendarClock className="h-4 w-4 text-slate-400" />
        <h2 className="text-base md:text-lg font-semibold text-slate-900">{data.month} {data.last_year} — what happened last year</h2>
      </div>
      {empty ? (
        <p className="text-sm text-slate-500" data-testid="last-year-empty">{data.has_history ? `No notable price moves in ${data.month} ${data.last_year}.` : "Once you have a year of invoices, this shows how prices moved at this time last year and how today compares."}</p>
      ) : (
        <div className="space-y-3">
          {data.last_year_changes.length > 0 && <div>
            <p className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-1.5">Moved in {data.month} {data.last_year}</p>
            <div className="flex gap-2 overflow-x-auto pb-1">{data.last_year_changes.map((c) => <Chip key={c.supplier_product_id} c={c} />)}</div>
          </div>}
          {data.year_on_year.length > 0 && <div>
            <p className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-1.5">Today vs {data.month} {data.last_year}</p>
            <div className="flex gap-2 overflow-x-auto pb-1">{data.year_on_year.map((c) => <Chip key={c.supplier_product_id} c={c} />)}</div>
          </div>}
        </div>
      )}
    </section>
  );
}
